/* Analytics as a listener. Components announce what happened in their own
   terms, as DOM events, and this is the only place that knows GA4 exists:
   the table below is the whole mapping from those announcements to gtag
   events. To track something new, dispatch an event and add a row.

   gtag() exists only once the visitor has accepted analytics cookies (the
   tag is a dormant placeholder until then; see _includes/_head/analytics.twig
   and cookieConsent.js) and only where GOOGLE_ANALYTICS_ID is set, so its
   absence is both the consent check and the local-dev no-op. */

const events = {
  "checkout-opened": ({ checkoutType }) => ["begin_checkout", { checkout_type: checkoutType }],
};

/* Announced before the visitor has decided, an event waits here: sent if
   they accept, dropped if they decline. Nothing leaves the browser first,
   and nothing survives leaving the page. */
let pending = [];

function send(args) {
  if (typeof window.gtag !== "function") {
    pending.push(args);
    return;
  }

  window.gtag("event", ...args);
}

for (const [name, toGtagArgs] of Object.entries(events)) {
  window.addEventListener(name, (event) => send(toGtagArgs(event.detail ?? {})));
}

window.addEventListener("cookie-consent", ({ detail }) => {
  const queued = pending;
  pending = [];

  if (detail === "all") {
    queued.forEach(send);
  }
});
